export { default as HtmlHead } from './HtmlHead'

export { default as Page } from './Page/Page'
export { default as PageWrapper } from './Page/PageWrapper'
export { default as PageContent } from './Page/PageContent'
export { default as PageSection } from './Page/PageSection'

export { default as SidePanel } from './SidePanel/SidePanel'
export { default as Sidebar } from './Sidebar/Sidebar'
export { default as Footer } from './Footer/Footer'
export { default as Searchbar } from './Searchbar/Searchbar'

export { default as Button } from './Button/Button'
export { default as BurgerMenu } from './Button/BurgerMenu'
export { default as InputText } from './InputText/InputText'



// WEBPACK FOOTER //
// ./component/ui/index.js